import React from "react";
import { render } from "react-dom";
import RouterContainer from "./react/RouterContainer";
import "./styles";
import ChromeWarning from "./react/ChromeWarning";

import { Provider } from "react-redux";
import "@babel/polyfill";
import "./debug";
import "./info";
import store from "./storeInstance";

window.addEventListener("load", function() {
  let el = document.createElement("div");
  el.className = "root autotest-backoffice-webapp";

  document.body.appendChild(el);
  render(
    <Provider store={store}>
      <ChromeWarning>
        <RouterContainer />
      </ChromeWarning>
    </Provider>,
    el,
  );
});
